import './Offerbar.css'
function OfferBar() {
  return (
    <div className="fk-offer-bar">
      <p>
        🔥 Get Up To <span>50% OFF</span> On Your First Order — Shop Now!
      </p>
    </div>
  );
}

export default OfferBar;
